import { generateListUidToName } from '@/helper/uidToName'
import { addGetParameters } from '@/helper/requests'

export default {
  data () {
    return {
      search: {
        value: '',
        parameter: 'q',
        in_process: false
      },
      options: {
        sortBy: []
      },
      pagination: {
        size_name: 'size',
        page_name: 'page',
        need_reload: false,
        page: 1,
        count: 0,
        size: 25,
        next: false,
        previous: false,
        loading: false,
        current: null,
        filters: {},
        footer_page: {
          'items-per-page-options': [10, 25, 50],
          'show-current-page': true,
          'show-first-last-page': true
        }
      }
    }
  },
  watch: {
    'options.sortBy': function (nVal, oVal) {
      /**
       * Обрабатывает изменение параметров сортировки
       */
      let url = this.getCurrentLoadUrl()

      if (Object.keys(nVal) !== Object.keys(oVal)) {
        if (Object.keys(this.options.sortBy).length !== 0) {
          url = this.getCurrentLoadUrl()
          let sortParam = null
          let sortDesc = null
          let sendSort = ''

          sortParam = Object.assign({}, this.options.sortBy)
          sortDesc = Object.assign({}, this.options.sortDesc)

          let countKey = Object.keys(sortParam).length
          for (const a in sortDesc) {
            if (sortDesc[a]) {
              sortParam[a] = '-' + sortParam[a]
            }
            countKey--
            if (countKey === 0) {
              sendSort = sendSort + sortParam[a]
            } else {
              sendSort = sendSort + sortParam[a] + ','
            }
          }

          if (url && sendSort.length > 0) {
            url = this.addGetParameter(
              this.getCurrentLoadUrl(),
              'ordering',
              sendSort
            )

            this.setCurrentLoadUrl(
              this.addFiltersParameter(
                url
              ),
              true
            )
          }
        }
      }
    },
    'pagination.page': function (nVal, oVal) {
      /**
       * Обрабатывает изменение номера страницы
       */
      this.setCurrentLoadUrl(
        this.addPageParameter(
          this.getCurrentLoadUrl()
        )
      )
    },
    'pagination.size': function (nVal, oVal) {
      /**
       * Обрабатывает изменение размера страницы
       */
      this.setCurrentLoadUrl(
        this.addSizeParameter(
          this.getCurrentLoadUrl()
        )
      )
    },
    'pagination.filters': {
      /**
       * Обрабатывает изменение фильтров
       */
      deep: true,
      handler: function (nVal, oVal) {
        this.cleanPaginationPageData()
        this.setCurrentLoadUrl(
          this.addFiltersParameter(
            this.getCurrentLoadUrl()
          )
        )
      }
    },
    'pagination.current': function (nVal, oVal) {
      /**
       * Обрабатывает изменение текущего URL загрузки
       */
      if (nVal !== oVal && this.pagination.need_reload) {
        this.loadData(
          this.getCurrentLoadUrl()
        )
      }
      if (!this.pagination.need_reload) {
        this.pagination.need_reload = true
      }
    }

  },
  methods: {
    cleanPaginationPageData () {
      /**
       * Сбрасывает данные о текущей странице пагинации
       */
      this.pagination.page = 1
      // this.need_reload = false;
    },
    cleanPaginationData () {
      /**
       * Сбрасывает все данные пагинации
       */
      this.pagination.size = 10
      this.pagination.count = 0
      this.pagination.page = 1
      // this.need_reload = false;
    },
    mapResults: function (from, to) {
      /**
       * Сохраняет результаты запроса в указанное место
       * @param {Object} from - объект с данными из API
       * @param {string} to - имя свойства для сохранения результатов
       */
      this[to] = from.results
      this.mapPagination(from)
    },
    mapPagination: function (from) {
      /**
       * Обновляет данные пагинации из ответа API
       * @param {Object} from - объект с данными из API
       */
      this.pagination.count = from.count
      this.pagination.next = from.next !== null
      this.pagination.previous = from.previous !== null
    },
    setCurrentLoadUrl (url) {
      /**
       * Устанавливает текущий URL для загрузки данных
       * @param {string} url - URL для загрузки данных
       */
      this.pagination.current = url
    },
    getCurrentLoadUrl () {
      /**
       * Получает текущий URL для загрузки данных
       * @returns {string} текущий URL
       */
      return this.pagination.current
    },
    loadNames: function (data, uid, fio, finalizer = () => {
      /**
       * Загружает ФИО пользователей по их UID
       * @param {Array} data - массив объектов с данными пользователей
       * @param {string} uid - имя поля с UID пользователя
       * @param {string} fio - имя поля для сохранения ФИО
       * @param {Function} finalizer - функция обратного вызова после завершения
       */
    }) {
      data.forEach(el => {
        this.$set(el, fio, '')
      })
      generateListUidToName(data, uid, fio, finalizer)
    },
    /**
     * Включает состояние загрузки
     */
    setLoading () {
      this.pagination.loading = true
    },
    setNotLoading () {
      /**
       * Выключает состояние загрузки
       */
      this.pagination.loading = false
    },
    addSizeParameter (url) {
      /**
       * Добавляет параметр размера страницы в URL
       * @param {string} url - исходный URL
       * @returns {string} URL с добавленным параметром размера
       */
      return this.addGetParameter(
        url,
        this.pagination.size_name,
        this.pagination.size
      )
    },
    addPageParameter (url) {
      /**
       * Добавляет параметр номера страницы в URL
       * @param {string} url - исходный URL
       * @returns {string} URL с добавленным параметром страницы
       */
      return this.addGetParameter(
        url,
        this.pagination.page_name,
        this.pagination.page
      )
    },
    addSearchParameter (url) {
      /**
       * Добавляет параметр поиска в URL
       * @param {string} url - исходный URL
       * @returns {string} URL с добавленным параметром поиска
       */
      return this.addGetParameter(
        url,
        this.search.parameter,
        this.search.value
      )
    },
    addFiltersParameter (url) {
      /**
       * Добавляет параметры фильтров в URL
       * @param {string} url - исходный URL
       * @returns {string} URL с добавленными параметрами фильтров
       */
      return this.addGetParameters(
        url,
        this.pagination.filters
      )
    },
    addGetParameters (url, parameters) {
      /**
       * Добавляет несколько параметров в URL
       * @param {string} url - исходный URL
       * @param {Object} parameters - объект с параметрами
       * @returns {string} URL с добавленными параметрами
       */
      return addGetParameters(url, parameters)
    },
    addGetParameter (url, key, value) {
      /**
       * Добавляет один параметр в URL
       * @param {string} url - исходный URL
       * @param {string} key - ключ параметра
       * @param {any} value - значение параметра
       * @returns {string} URL с добавленным параметром
       */
      return addGetParameters(url, {
        [key]: value
      })
    },
    searchData: function () {
      /**
       * Выполняет поиск с сохранением параметров в URL
       */
      this.cleanPaginationPageData()
      this.setCurrentLoadUrl(
        this.addSearchParameter(
          this.getCurrentLoadUrl()
        )
      )
    },
    reloadData: function () {
      /**
       * Перезагружает данные
       */
      this.clearData()
      this.loadData(this.getCurrentLoadUrl())
    },
    clearData () {
      /**
       * Очищает данные (должен быть переопределен в компоненте)
       */
    },
    loadData (url = undefined) {
      /**
       * Загружает данные (должен быть переопределен в компоненте)
       * @param {string} url - URL для загрузки данных
       */
    }
  }
}
